import React, { useState, useContext, useEffect, Fragment } from 'react';
import { AuthContext } from '../contexts/auth';
import { Dialog, Transition } from '@headlessui/react'
import { PencilSquareIcon, TrashIcon, BriefcaseIcon } from '@heroicons/react/24/outline';
import { deleteTimeSlotCompany, updateWorkingHoursCompany, deleteWorkingHours } from '../services/api_working_hours';
import Swal from 'sweetalert2';
import EditTimeSlot from './edit_time_slot';
import AddNewTimeSlot from './add_new_time_slot';
import { formatTime } from '../utils/timeslots';
import { listOrganizationalUnits } from '../services/api_org_unit';
import ComboboxAutocomplete from './combobox_autocomplete';
import Fetching from './fetching';
import Empty from './empty';
import LocalBarIcon from '@mui/icons-material/LocalBar';
import CustomTooltipComponent from './custom_tooltip_component';
import { getTimeSlotsDuration, formatHoursAndMinutes } from '../utils/workTimeCount';



// ANTEPRIMA TURNI GIORNALIERI SALVATI

const ShiftTableDailyShow = ({ workingHours, loading, onDeleteShift, onDeleteTimeSlot, onUpdateWorkingHours, onUnitChange }) => {
  const { token } = useContext(AuthContext);
  const [editTimeSlot, setEditTimeSlot] = useState(null);
  const [editTimeSlotIndex, setEditTimeSlotIndex] = useState(null);
  const [workingHoursData, setWorkingHoursData] = useState(workingHours);
  const [workingHourId, setWorkingHourId] = useState(null); 
  const [updatedTimeSlot, setUpdatedTimeSlot] = useState(null);
  const [addTimeSlot, setAddTimeSlot] = useState(false);
  const [error, setError] = useState('');
  const [openEditTimeSlotDialog, setOpenEditTimeSlotDialog] = useState(false);
  const [openCreateTimeSlotDialog, setOpenCreateTimeSlotDialog] = useState(false);
  const [isEditingName, setIsEditingName] = useState({});
  const [newNameWh, setNewNameWh] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [units, setUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState(null);
  
  useEffect(() => {
    async function fetchData() {
      try {
        const unitsData = await listOrganizationalUnits(token, true);
        setUnits(unitsData.data);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching units:', error);
        setError(true);
        setIsLoading(false);
      }
    }
    fetchData();
  }, [token]);

  const handleSelectUnit = (selected) => {
    const unit = selected === 'all' || !selected ? null : selected;
    setSelectedUnit(unit);
    onUnitChange(unit, 'GIORNALIERO');
  };

  const handleResetSelection = () => {
    setSelectedUnit(null);
    onUnitChange(null, 'GIORNALIERO');
  };
  
  
  // const filteredWorkingHoursData = selectedUnit
  //   ? workingHoursData.filter(item => item.unitId === selectedUnit)
  //   : workingHoursData;
  
  // console.log('check filtered', filteredWorkingHoursData);
  
  useEffect(() => {
    if (units.length > 0) {
      const updatedWorkingHours = workingHours.map((workingHour) => {
        const associatedUnit = units.find((unit) => unit.id === workingHour.ou);
        return {
          ...workingHour,
          ouName: associatedUnit ? associatedUnit.name : 'Unità sconosciuta',
        };
      });
      setWorkingHoursData(updatedWorkingHours);
    }
  }, [workingHours, units]);
    

  const handleUpdatedTimeSlot = (updatedTimeSlot) => {
    const updatedWorkingHoursData = workingHoursData.map((workingHour) => {
      const updatedTimeSlots = workingHour.time_slots.map((timeSlot) => {
        if (timeSlot.id === updatedTimeSlot.id) {
          return updatedTimeSlot;
        }
        return timeSlot;
      });
      return { ...workingHour, time_slots: updatedTimeSlots };
    });
    setWorkingHoursData(updatedWorkingHoursData);
    onUpdateWorkingHours(updatedWorkingHoursData);
  };

  // const handleDeleteShift = (id: number) => {
  //   onDeleteShift(id);
  //   setWorkingHoursData((prevData) => (prevData.filter(whd => whd.id !== id)))
  // };

  const handleDeleteShift = async (id) => {
    Swal.fire({
      icon: "warning",
      text: `Il turno giornaliero verrà eliminato anche dai turni settimanali nei quali è stato assegnato. Sei sicuro di voler procedere?`,
      showCancelButton: true,
      confirmButtonText: "Sì",
      cancelButtonText: "Annulla",
      cancelButtonColor: "#d1d5db",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteWorkingHours(token, id);
          const updatedWorkingHours = workingHours.filter(shift => shift.id !== id);
          setWorkingHoursData(updatedWorkingHours);
          onDeleteShift(id)
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Turno eliminato con successo!",
            showConfirmButton: false,
            timer: 1500
          });
        } catch (error) {
          console.error('Errore durante l\'eliminazione del turno', error);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Errore durante l'eliminazione del turno",
          });
        }
      }
    });
  };
  
  const handleEditTimeSlot = (selectedTimeSlot, index = 0, workingHourId) => {
    setError('');
    if (addTimeSlot) {
      setError("Per procedere con la modifica della fascia oraria è necessario chiudere la creazione della nuova fascia oraria");
      return;
    }
    setEditTimeSlot([selectedTimeSlot]);
    setEditTimeSlotIndex(index);
    setWorkingHourId(workingHourId);
    setOpenEditTimeSlotDialog(true);
  };

  const handleDeleteTimeSlot = async (id) => {
    Swal.fire({
      icon: "warning",
      text: `La fascia oraria verrà eliminata anche dai turni settimanali nei quali è stato assegnato il turno giornaliero. Sei sicuro di voler procedere?`,
      showCancelButton: true,
      confirmButtonText: "Sì",
      cancelButtonText: "Annulla",
      cancelButtonColor: "#d1d5db",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteTimeSlotCompany(token, id);
          
          const updatedWorkingHours = workingHoursData.map(wh => {
            if (wh.time_slots.some(slot => slot.id === id)) {
              const updatedTimeSlots = wh.time_slots.filter(slot => slot.id !== id);
              return { ...wh, time_slots: updatedTimeSlots };
            }
            return wh;
          });
  
          setWorkingHoursData(updatedWorkingHours);
  
          if (onDeleteTimeSlot) {
            onDeleteTimeSlot(id);
          }
  
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Eliminato!",
            showConfirmButton: false,
            timer: 1500
          });
        } catch (error) {
          console.error('Errore durante l\'eliminazione della fascia oraria', error);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Errore durante l'eliminazione della fascia oraria"
          });
        }
      }
    });
  };

  const handleAddTimeSlot = (workingHourId) => {
    setError('');
    if (editTimeSlot !== null) {
      setError("Concludi prima l'attuale operazione di modifica.");
      return;
    }
    setWorkingHourId(workingHourId);
    setAddTimeSlot(true);
    setOpenCreateTimeSlotDialog(true);
  };
  
  const handleCreateTimeSlot = (newTimeSlot) => {
    const updatedWorkingHoursData = workingHoursData.map((workingHour) => {
      if (workingHour.id === newTimeSlot.object_id) {
        const updatedTimeSlots = [...workingHour.time_slots, newTimeSlot];
        
        return {
          ...workingHour,
          time_slots: updatedTimeSlots,
        };
      }
      return workingHour;
    });
    onUpdateWorkingHours(updatedWorkingHoursData);
  };

  useEffect(() => {
    setWorkingHoursData(workingHours);
  }, [workingHours]);
  
  const handleCancelAddTimeSlot = () => {
    setWorkingHourId(null);
    setAddTimeSlot(false);
  };

  const handleEditNameClick = (index, name) => {
    setNewNameWh(name); 
    setIsEditingName({ ...isEditingName, [index]: true }); 
  };


  const handleSaveNameClick = async (index) => {
    try {
      setIsSaving(true);
      const updatedWorkingHour = await updateWorkingHoursCompany(token, workingHoursData[index].id, newNameWh);
  
      const updatedWorkingHoursData = [...workingHoursData];
      updatedWorkingHoursData[index].name = newNameWh;
      setWorkingHoursData(updatedWorkingHoursData);
      onUpdateWorkingHours(updatedWorkingHoursData)
  
      setIsEditingName({ ...isEditingName, [index]: false });
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Salvato!",
        showConfirmButton: false,
        timer: 1500
      });
    } catch (error) {
      console.error('Errore durante il salvataggio del nome del turno:', error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Errore durante l'aggiornamento",
      });
    } finally {
      setIsSaving(false);
    }
  };

  const handleCancelNameClick = (index) => {
    setIsEditingName({ ...isEditingName, [index]: false }); 
  };


  return (
    <div className="m-5 border border-solid-2 border-gray-200 rounded-md shadow-md" style={{ minHeight: '100vh', maxHeight: '100vh', overflowY: 'auto' }}>
      <div className='grid grid-cols-3 bg-gray-50 text-sm  font-bold text-gray-500 text-center py-3 uppercase sticky top-0 z-10 items-center'>
        <div className='col-span-1'></div>
        <div className='col-span-1 justify-end underline'>
           Turni Giornalieri 
        </div>
        <div className="col-span-3 mt-2">
          {selectedUnit?.id ? (
            <>
              Stai visualizzando i turni dell'Unità{" "}
              <span className="text-indigo-600 font-semibold">{selectedUnit.name}</span>
            </>
          ) : (
            <>
              Stai visualizzando i turni giornalieri{" "}
              <span className="text-indigo-600 font-semibold">GENERICI</span>
            </>
          )}
        </div>
      </div>
      <div className='bg-gray-50 text-sm flex text-gray-500 text-center py-3 pb-6 uppercase sticky top-[70px] z-10 items-center justify-between px-4'>
        <div className='px-5 font-bold flex-shrink-0'>
          Visualizza
        </div>
        <div className='me-5 w-1/2 z-10'>
          <ComboboxAutocomplete
            options={units}
            bgActiveColor="bg-indigo-50"
            textActiveColor="text-gray-900"
            placeholder="Seleziona l'Unità Organizzativa per visualizzare i turni collegati alla specifica Unità"
            onChange={handleSelectUnit}
            value={selectedUnit}
            positionOptions='absolute'
          />
        </div>
        <button
          className={`inline-flex items-center rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${!selectedUnit ? 'invisible' : ''}`}
          onClick={handleResetSelection}
          disabled={!selectedUnit}
        >
          Reset selezione
        </button>
      </div>

      <div className="space-y-6 mt-2 px-8">
        <>
          {loading && (
            <div className='min-w-full text-center text-sm font-medium text-gray-600 py-5'>
              <Fetching />
            </div>
          )}

          {!loading && (
            <>
              {workingHoursData && workingHoursData.length > 0 ? (
                <div className="space-y-6">
                  {workingHoursData
                    .sort((a, b) => b.id - a.id)
                    .map((workingHour, index) => {
                      const totalHours = getTimeSlotsDuration(workingHour?.time_slots || []);
                      const formattedDuration = formatHoursAndMinutes(totalHours);

                      return (
                        <div key={index} className="border-b border-gray-200 pb-4">
                          {/* HEADER */}
                          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 pt-3">
                            <div className="flex items-center space-x-3 flex-wrap">
                            {isEditingName[index] ? (
                                <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-3 w-full">
                                  {/* Input sopra su mobile, a sinistra su desktop */}
                                  <input
                                    type="text"
                                    value={newNameWh}
                                    onChange={(e) => setNewNameWh(e.target.value)}
                                    className="text-sm font-medium text-gray-700 py-2 px-3 rounded border border-gray-300 focus:outline-none focus:border-indigo-500 w-full sm:w-auto"
                                  />
                                  
                                  {/* Bottoni sotto su mobile, a destra su desktop */}
                                  <div className="flex flex-row sm:flex-row mt-2 sm:mt-0 sm:space-x-2 justify-center">
                                    <button
                                      onClick={() => handleSaveNameClick(index)}
                                      className="text-xs font-semibold text-white bg-indigo-600 hover:bg-indigo-500 py-1.5 px-4 rounded uppercase"
                                      disabled={isSaving}
                                    >
                                      {isSaving ? 'Salvataggio...' : 'Salva'}
                                    </button>
                                    <button
                                      onClick={() => handleCancelNameClick(index)}
                                      className="text-xs font-semibold text-gray-700 bg-gray-200 py-1.5 px-4 rounded uppercase ml-2 sm:ml-0"
                                    >
                                      Annulla
                                    </button>
                                  </div>
                                </div>
                              ) : (
                                <>
                                  <div className="text-sm font-bold uppercase text-gray-600">{workingHour.name}</div>
                                  <button
                                    onClick={() => handleEditNameClick(index, workingHour.name)}
                                    className="text-sm font-medium text-gray-700 ml-4"
                                  >
                                    <PencilSquareIcon className="w-5 h-5" />
                                  </button>
                                </>
                              )}
                            </div>

                            {/* Pulsante elimina turno */}
                            <div className="flex sm:mt-0 justify-end">
                              <button
                                onClick={() => handleDeleteShift(workingHour.id)}
                                className="bg-indigo-600 text-white text-sm px-2 py-1 font-semibold rounded-md hover:bg-indigo-500"
                              >
                                ELIMINA TURNO
                              </button>
                            </div>
                          </div>

                          {workingHour?.ou && (
                            <div className="justify-center text-left items-center py-2">
                              <span className="text-xs font-bold text-gray-500 rounded-md bg-indigo-50 p-1">Unità associata: {workingHour.ou_name}</span>
                            </div>
                          )}

                          {formattedDuration && (
                            <div className="text-gray-700 text-left text-sm font-semibold">
                              Totale ore giornaliere: {formattedDuration}
                            </div>
                          )}

                          {/* TIME SLOTS */}
                          <div className="mt-4">
                            <table className="w-full table-fixed border border-gray-200 rounded-lg shadow text-sm">
                              <thead className="bg-indigo-50 text-center">
                                <tr>
                                  <th className="px-4 py-2 text-gray-600 w-[40%]">
                                    <BriefcaseIcon className="w-4 h-4 text-indigo-700 me-1 inline-block" /> Fascia Oraria
                                  </th>
                                  <th className="px-4 py-2 text-gray-600 w-[40%]">
                                    <LocalBarIcon style={{ height: '15px', width: '15px', color: '#4f46e5', marginRight: '4px' }} /> Pausa
                                  </th>
                                  <th className="px-4 py-2 text-gray-600 w-[20%]">Azioni</th>
                                </tr>
                              </thead>
                              <tbody>
                                {workingHour.time_slots
                                  .sort((a, b) => a.start_at.localeCompare(b.start_at))
                                  .map((timeSlot, slotIndex) => (
                                    <tr key={slotIndex} className="text-center">
                                      <td className="border px-4 py-2 font-medium">
                                        {formatTime(timeSlot.start_at)} - {formatTime(timeSlot.end_at)}
                                      </td>
                                      <td className="border px-4 py-2">
                                        {timeSlot.breaks.length > 0 ? (
                                          <div className="space-y-1">
                                            {timeSlot.breaks.map((brk, brkIdx) => (
                                              <div key={brkIdx} className="flex items-center justify-center space-x-1 text-gray-600">
                                                <span>{formatTime(brk.start_at)} - {formatTime(brk.end_at)}</span>
                                              </div>
                                            ))}
                                          </div>
                                        ) : (
                                          <span className="text-gray-400">Nessuna</span>
                                        )}
                                      </td>
                                      <td className="border px-2 py-2">
                                        <div className="flex justify-center space-x-2">
                                          <CustomTooltipComponent title='Modifica fascia oraria' placement="bottom" arrow>
                                            <button
                                              className="p-1"
                                              onClick={() => handleEditTimeSlot(timeSlot, index, workingHour.id)}
                                            >
                                              <PencilSquareIcon className="h-5 w-5 text-indigo-800 hover:text-indigo-500" />
                                            </button>
                                          </CustomTooltipComponent>
                                          <CustomTooltipComponent title='Elimina' placement="bottom" arrow>
                                            <button
                                              className="p-1"
                                              onClick={() => handleDeleteTimeSlot(timeSlot.id)}
                                            >
                                              <TrashIcon className="h-5 w-5 text-indigo-800 hover:text-red-500" />
                                            </button>
                                          </CustomTooltipComponent>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>

                            {/* Aggiungi fascia */}
                            {!addTimeSlot && !editTimeSlot && (
                              <button
                                onClick={() => handleAddTimeSlot(workingHour.id)}
                                className="mt-4 w-full text-sm text-indigo-800 font-semibold text-center py-2 border border-gray-300 rounded hover:bg-indigo-100 uppercase"
                              >
                                Aggiungi fascia oraria
                              </button>
                            )}
                          </div>


                          {/* DIALOG: AGGIUNTA FASCIA */}
                          {addTimeSlot && workingHourId === workingHour.id && openCreateTimeSlotDialog && (
                            <Transition.Root show={openCreateTimeSlotDialog} as={Fragment}>
                              <Dialog className="relative z-10" onClose={() => {}} static>
                                <Transition.Child
                                  as={Fragment}
                                  enter="ease-out duration-300"
                                  enterFrom="opacity-0"
                                  enterTo="opacity-100"
                                  leave="ease-in duration-200"
                                  leaveFrom="opacity-100"
                                  leaveTo="opacity-0"
                                >
                                  <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                                </Transition.Child>

                                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                                  <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                    <Transition.Child
                                      as={Fragment}
                                      enter="ease-out duration-300"
                                      enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                      enterTo="opacity-100 translate-y-0 sm:scale-100"
                                      leave="ease-in duration-200"
                                      leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                      leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                    >
                                      <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-gray-50 items-center flex justify-center mx-8 shadow-xl transition-all my-8 w-3/4">

                                      <div className='w-full'>
                                        <div className='col-span-3 px-4 pb-4 bg-gray-50'>
                                          {error && (
                                            <div className="grid grid-cols-1 mx-4 mt-3">
                                              <p className="text-red-500 text-sm text-center">{error}</p>
                                            </div>
                                          )}
                                          <AddNewTimeSlot 
                                            workingHour={workingHour}
                                            onCancelEdit={handleCancelAddTimeSlot}
                                            onAddTimeSlot={handleCreateTimeSlot} 
                                          />
                                        </div>
                                      </div>
                                      </Dialog.Panel>
                                    </Transition.Child>
                                  </div>
                                </div>
                              </Dialog>
                            </Transition.Root>
                          )}

                          {/* DIALOG: MODIFICA FASCIA */}
                          {editTimeSlot !== null && editTimeSlotIndex === index && openEditTimeSlotDialog && (
                            <Transition.Root show={openEditTimeSlotDialog} as={Fragment}>
                              <Dialog className="relative z-10" onClose={() => {}} static>
                                <Transition.Child
                                  as={Fragment}
                                  enter="ease-out duration-300"
                                  enterFrom="opacity-0"
                                  enterTo="opacity-100"
                                  leave="ease-in duration-200"
                                  leaveFrom="opacity-100"
                                  leaveTo="opacity-0"
                                >
                                  <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                                </Transition.Child>
                          
                                <div className="fixed inset-0 z-10 overflow-y-auto">
                                  <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                                    <Transition.Child
                                      as={Fragment}
                                      enter="ease-out duration-300"
                                      enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                      enterTo="opacity-100 translate-y-0 sm:scale-100"
                                      leave="ease-in duration-200"
                                      leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                      leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                    >
                                      <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-gray-50 items-center flex justify-center mx-8 shadow-xl transition-all my-8 w-3/4">
                                        <div className='w-full'>
                                          <div className='w-full px-4 pb-4 bg-gray-50'>
                                            {error && (
                                              <div className="grid grid-cols-1 mx-4">
                                                <p className="text-red-500 text-sm text-center">{error}</p>
                                              </div>
                                            )}

                                            <EditTimeSlot
                                              timeSlotObject={editTimeSlot[0]}
                                              onClose={() => setEditTimeSlot(null)}
                                              onShiftPreview={() => setEditTimeSlot(null)}
                                              onCancelEdit={() => setEditTimeSlot(null)}
                                              onUpdatedTimeSlot={handleUpdatedTimeSlot}
                                              timeSlots={workingHour ? workingHour.time_slots : []}
                                            />
                                          </div>
                                        </div>
                                      </Dialog.Panel>
                                    </Transition.Child>
                                  </div>
                                </div>
                              </Dialog>
                            </Transition.Root>
                          )}
                        </div>);
                      }
                    )
                  }
                </div>
              ) : (
                <div className="text-center text-sm text-gray-600 font-medium py-10">
                  <Empty />
                </div>
              )}
            </>
          )}
        </>
      </div>
      
    </div>
  );
}

export default ShiftTableDailyShow;

